(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cursor = document.querySelector('.nutsy-cursor');

  if (!cursor || !finePointer.matches || reducedMotion.matches) return;

  document.documentElement.classList.add('nutsy-cursor-ready');

  const interactiveSelector = 'a, button, summary, [role="button"], input[type="submit"], input[type="button"], .shopify-payment-button';
  let targetX = window.innerWidth / 2;
  let targetY = window.innerHeight / 2;
  let currentX = targetX;
  let currentY = targetY;
  let frame;

  const animate = () => {
    currentX += (targetX - currentX) * 0.2;
    currentY += (targetY - currentY) * 0.2;
    cursor.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
    frame = requestAnimationFrame(animate);
  };

  const setInteractive = (event) => {
    const target = event.target instanceof Element ? event.target.closest(interactiveSelector) : null;
    const disabled = target && (target.matches(':disabled') || target.getAttribute('aria-disabled') === 'true');
    cursor.classList.toggle('is-interactive', Boolean(target && !disabled));
  };

  document.addEventListener('pointermove', (event) => {
    targetX = event.clientX;
    targetY = event.clientY;
    cursor.classList.add('is-visible');
    setInteractive(event);
  }, { passive: true });

  document.addEventListener('pointerover', setInteractive, { passive: true });
  document.addEventListener('pointerdown', () => cursor.classList.add('is-pressed'), { passive: true });
  document.addEventListener('pointerup', () => cursor.classList.remove('is-pressed'), { passive: true });
  document.addEventListener('pointercancel', () => cursor.classList.remove('is-pressed'), { passive: true });
  document.documentElement.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
  window.addEventListener('blur', () => cursor.classList.remove('is-visible'));

  frame = requestAnimationFrame(animate);

  window.addEventListener('pagehide', () => {
    if (frame) cancelAnimationFrame(frame);
  }, { once: true });
})();
